export default defineNuxtPlugin((nuxtApp) => {
  const userAuth = useCookie("auth.token");
  const config = useRuntimeConfig();
  const apiKey = config.public.apiKey;

  const toast = useToast();

  const $customFetch = $fetch.create({
    baseURL: config.public.apiUrl,
    onRequest({ request, options, error }) {
      const headers = (options.headers ||= new Headers());

      if (Array.isArray(headers)) {
        headers.push(["Accept", "application/json"]);
        headers.push(["X-Frontend-Key", apiKey]);
        if (userAuth.value)
          headers.push(["Authorization", `Bearer ${userAuth.value}`]);
      } else if (headers instanceof Headers) {
        headers.set("Accept", "application/json");
        headers.set("X-Frontend-Key", apiKey);
        if (userAuth.value)
          headers.set("Authorization", `Bearer ${userAuth.value}`);
      } else {
        const typedHeaders = headers as Record<string, string>;
        typedHeaders["Accept"] = "application/json";
        typedHeaders["X-Frontend-Key"] = apiKey;
        if (userAuth.value)
          typedHeaders.Authorization = `Bearer ${userAuth.value}`;
      }
    },
    async onResponse({ response }) {
      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo("/signin"));
      }
    },
    async onResponseError({ response }) {
      console.error("error response", response);
      const errorMsg = response._data?.errors?.at(0) || response._data?.message;
      toast.add({
        severity: "error",
        summary: "Oops! Status code - " + response.status,
        detail: errorMsg ?? "Internal server error.",
        life: 6000,
      });

      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo("/signin"));
      }
    },
  });
  // Expose to useNuxtApp().$customFetch
  return {
    provide: {
      customPublicFetch: $customFetch,
    },
  };
});
